import React, { Component } from 'react';

import Header from './Header'
import Order from './Order'
import Inventory from './Inventory'
import Fish from './Fish'

import sampleFishes from '../sample-fishes';
import base from '../base';


class App extends Component {
	constructor() {
		super();

		this.addFish = this.addFish.bind(this);
		this.updateFish = this.updateFish.bind(this);
		this.removeFish = this.removeFish.bind(this);
		this.loadSamples = this.loadSamples.bind(this);
		this.addToOrder = this.addToOrder.bind(this);
		this.removeFromOrder = this.removeFromOrder.bind(this);

		this.state = {
			fishes: {},
			order: {}
		};
	}

	// invoked once, both on client and server side
	componentWillMount() {
		this.ref = base.syncState(`${this.props.params.storeId}/fishes`, {
			context: this,
			state: 'fishes'
		});

		// check if there is any order in localStorage
		const localStorageRef = localStorage.getItem(`order-${this.props.params.storeId}`);
		if (localStorageRef) {
			// update our app component's order state
			this.setState({
				order: JSON.parse(localStorageRef) // turn the string back into object
			});
		}
	}


	componentWillUnmount() {
		base.removeBinding(this.ref);
	}

	componentWillUpdate(nextProps, nextState) {
		localStorage.setItem(`order-${this.props.params.storeId}`, JSON.stringify(nextState.order));
	}

	addFish(fish) {
		// update our state
		const fishes = {...this.state.fishes};
		// add our new fish
		const timestamp = Date.now();
		fishes[`fish-${timestamp}`] = fish;

		// set state
		this.setState({ 
			fishes
		})
	}

	updateFish(key, updatedFish) {
		const fishes = {...this.state.fishes};
		fishes[key] = updatedFish;
		this.setState({
			fishes
		})
	}

	removeFish(key) {
		const fishes = {...this.state.fishes};
		fishes[key] = null; // delete doesn't work in this instance
		this.setState({
			fishes
		});
	}


	loadSamples() {
		this.setState({
			fishes: sampleFishes
		})
	}

	addToOrder(key) {
		// take copy of state
		const order = {...this.state.order};

		// update/add new number of ordered fish
		order[key] = order[key] + 1 || 1;

		// update state
		this.setState({
			order
		})
	}

	removeFromOrder(key) {
		const order = {...this.state.order};
		delete order[key]; // can use delete, not limited by firebase
		this.setState({
			order
		})
	}

	render() {
		// Comment
		return (
			<div className="catch-of-the-day">
				<div className="menu">
					<Header tagline="Fresh Seafood Market" />
					<ul className="list-of-fishes">
					{
						Object
						.keys(this.state.fishes)
						.map(key => <Fish key={key} index={key} details={this.state.fishes[key]} addToOrder={this.addToOrder} />)
					}
					</ul>
				</div>
				<Order 
					fishes={this.state.fishes} 
					order={this.state.order} 
					removeFromOrder={this.removeFromOrder}
					params={this.props.params} />
				<Inventory 
					addFish={this.addFish} 
					updateFish={this.updateFish}
					removeFish={this.removeFish}
					loadSamples={this.loadSamples}
					fishes={this.state.fishes}
					storeID={this.props.params.storeID} />
			</div>
		)
	}
}

App.propTypes = {
	params: React.PropTypes.object.isRequired
}


export default App;


/** WEBPACK FOOTER **
 ** ./src/components/App.js
 **/